<div class="nhatky-edit-container">

  <!-- Form Card -->
  <div class="form-card">

    <!-- Content Section -->
    <div class="form-section">
      <div class="form-group-modern">
        <label class="form-label-modern">
          <i class="fas fa-edit"></i>
          <span>Nội dung chăm sóc</span>
          <span class="required-mark">*</span>
        </label>
        <div class="input-wrapper">
          <textarea 
            tabIndex="1" 
            rows="6" 
            class="form-control-modern" 
            placeholder="Nhập nội dung chi tiết về quá trình chăm sóc học sinh..." 
            [(ngModel)]="doituongSelect.NoiDung"
            #noiDungInput>
          </textarea>
          <div class="char-counter" *ngIf="doituongSelect.NoiDung">
            {{doituongSelect.NoiDung.length}} ký tự
          </div>
        </div>
      </div>
    </div>

    <!-- Additional Info Section -->
    <div class="form-section">
      <div class="row">
        <!-- Ghi chú -->
        <div class="col-md-6">
          <div class="form-group-modern">
            <label class="form-label-modern">
              <i class="far fa-sticky-note"></i>
              <span>Ghi chú</span>
            </label>
            <div class="input-wrapper">
              <input 
                type="text" 
                tabIndex="2" 
                class="form-control-modern" 
                placeholder="Ghi chú thêm (nếu có)..." 
                [(ngModel)]="doituongSelect.GhiChu">
            </div>
          </div>
        </div>

        <!-- Phản hồi -->
        <div class="col-md-6">
          <div class="form-group-modern">
            <label class="form-label-modern">
              <i class="fas fa-comments"></i>
              <span>Đánh giá phản hồi</span>
              <span class="required-mark">*</span>
            </label>
            <div class="input-wrapper">
              <ng-select 
                #slCapTren
                [tabIndex]="3"
                [openOnEnter]="false"
                [items]="inputphanhois"
                bindValue="Id"
                bindLabel="Ten"
                notFoundText="Không có dữ liệu"
                placeholder="Chọn mức độ phản hồi..."
                [(ngModel)]="doituongSelect.PhanHoi"
                class="ng-select-modern">
                <ng-template ng-option-tmp let-item="item">
                  <div class="feedback-option">
                    <i class="fas fa-circle" 
                       [ngClass]="{
                         'text-success': item.Id === 1,
                         'text-warning': item.Id === 2,
                         'text-danger': item.Id === 0
                       }"></i>
                    <span>{{item.Ten}}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Creator Info Section -->
    <div class="form-section info-section">
      <div class="form-group-modern">
        <label class="form-label-modern">
          <i class="fas fa-user-circle"></i>
          <span>Người tạo</span>
        </label>
        <div class="input-wrapper">
          <input 
            type="text" 
            tabIndex="4" 
            class="form-control-modern" 
            disabled="disabled" 
            [(ngModel)]="doituongSelect.CreatedBy">
        </div>
      </div>
    </div>

  </div>

</div>

<!-- Footer Actions -->
<div class="modal-footer-modern">
  <div class="footer-left">
    <div class="info-badge" *ngIf="doituongSelect.Id">
      <i class="fas fa-info-circle"></i>
      <span>Đang chỉnh sửa</span>
    </div>
    <div class="info-badge new-badge" *ngIf="!doituongSelect.Id">
      <i class="fas fa-plus-circle"></i>
      <span>Tạo mới</span>
    </div>
  </div>

  <div class="footer-right">
    <button 
      class="btn-modern btn-cancel" 
      (click)="closeModal()" 
      title="Ấn ESC để thoát">
      <i class="fas fa-times"></i>
      <span>Hủy bỏ</span>
      <span class="shortcut">ESC</span>
    </button>

    <button 
      *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" 
      type="submit" 
      (click)="saveproduct()" 
      title="Ấn F9 để lưu" 
      class="btn-modern btn-save"
      [disabled]="!doituongSelect.NoiDung || doituongSelect.PhanHoi === null || doituongSelect.PhanHoi === undefined">
      <i class="fas fa-save"></i>
      <span>Lưu lại</span>
      <span class="shortcut">F9</span>
    </button>
  </div>
</div>
